import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export function SubstitutePostingBadge({
  label,
  className,
  compact = false,
}: {
  label?: string | null;
  className?: string;
  compact?: boolean;
}) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-amber-300 bg-amber-50 text-amber-900 font-medium',
        compact ? 'text-[10px] px-1.5 py-0' : 'text-xs',
        className,
      )}
      title={label ?? 'Substitute posting'}
    >
      Substitute posting
    </Badge>
  );
}
